export { AssetsComponent } from "./assets.component";
export { AssetsModule } from "./assets.module";
export { AssetsRoutingModule } from "./assets-routing.module";
